import type { ReactNode } from 'react';

export const symbol_check_circle_unread: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-480Zm212-212q-32-32-32-78t32-78q32-32 78-32t78 32q32 32 32 78t-32 78q-32 32-78 32t-78-32ZM324-111.5Q251-143 197-197t-85.5-127Q80-397 80-480t31.5-156Q143-709 197-763t127-85.5Q397-880 480-880q24 0 48 3t47 9q12 3 17 14t1 22q-5 12-15.5 18t-22.5 3q-19-4-37.5-6.5T480-820q-142 0-241 99t-99 241q0 142 99 241t241 99q142 0 241-99t99-241q0-19-2.5-38t-6.5-37q-3-12 3-22.5t18-15.5q11-4 22 1t14 17q6 23 9 47t3 48q0 83-31.5 156T763-197q-54 54-127 85.5T480-80q-83 0-156-31.5ZM421-389l-98-98q-9-9-22-9t-23 10q-9 9-9 22t9 22l122 123q9 9 21 9t21-9l238-238q11-11 9.5-24t-9.5-21q-8-8-21-10t-24 9L421-389Z"
		/>
	</svg>
);
